(function($, undefined) {
	/*
     * Mathilde Paccoud
     * Last update 25/03/2017
     * 
     * Purpose : allows to store a value inside a 'double-click label'
     * 
     * @param : lang - language in which to update a label (double-clic)
     * @param : key - unique key to store a value in
     * @param : val - value to store in the label
     * @param : callback - any function to be called once value is stored
     * @param : reset - true/false - deletes label if true
     * 
     * Call : var labels = Fw.component.models().labels;
     */
	'use strict';
    
    var save = function(key,val,lang,callback,reset){
        var ap = actionPath || "/action/";
        
        ajax(ap + "addSiteLabel?lang=" + lang + "&key=" + key +
                "&value=" + (reset ? '' : encodeURIComponent(val)), callback, true);
    };
    
	var init = function (page) {
		var currPage = $(page);      
        
	};
    	
	var labels = Fw.component.export('labels', {
		init: init,
        save: save
	});
	
})(jQuery);